<script setup lang="ts">
import { inject, ref } from 'vue';
import StartAnalysisModal from '@/components/StartAnalysisModal.vue';

interface Props {
  files: File[];
}

defineProps<Props>();

const emit = defineEmits<{
  done: [];
}>();

// Confetti is owned globally by App.vue and exposed via provide/inject.
const triggerConfetti = inject<() => void>('triggerConfetti', () => {});

// The modal is shown as soon as this flow is mounted.
const show = ref(true);

const handleUpdateShow = (value: boolean): void => {
  show.value = value;
  if (!value) {
    emit('done');
  }
};

const handleAnalysisStarted = (): void => {
  emit('done');
};
</script>

<template>
  <StartAnalysisModal
    :show="show"
    :pre-uploaded-files="files"
    :trigger-confetti="triggerConfetti"
    @update:show="handleUpdateShow"
    @analysis-started="handleAnalysisStarted"
  />
</template>
